module.exports = "/images/vendor/flag-icon-css/flags/4x3/sn.svg?5b654e1a7246e45c6577b66c7b935620";